import { createAction, props } from '@ngrx/store';
import { Vle } from 'src/models/module-wise/user/vle';

export const paginateVles = createAction(
  '[ VLE ] Paginating'
);

export const loadVles = createAction(
  '[ VLE ] Load Vle',
  props<{ payload: Vle[], totalDocuments: number }>()
);

export const addVle = createAction(
  '[ VLE ] Add VLE',
  props<{ payload: Vle }>()
);

export const editVle = createAction(
  '[ VLE ] Edit Vle',
  props<{ payload: Vle | { status: string, _id: string } }>()
);

// export const updateSalesExecutive = createAction(
//   '[ VLE ] Update Sales Excutive Vle',
//   props<{ payload: Vle }>()
// );


export const removeVles = createAction(
  '[ VLE ] Delete Vle',
  props<{ payload: string[] }>()
);

export const removeAllVles = createAction(
  '[ VLE ] Remove All Vle'
);
